/**
 * Re-export des types generes par l'API et helpers de mapping
 */

import { CardState } from './cardState';
import { ContractStatus } from './enums';
import { CardStatusDtoStatusEnum } from 'api/quote';

// ============================================
// Re-exports des types generes par l'API
// ============================================

export type {
  CardStatusDto,
  CardStatuses,
  Permissions,
  DisabledReasons,
  CabinetMandateDto,
  EtatValidationDevis,
  DemandeValidationDto,
  DemanderValidationCommand,
  DevisPhoto,
  DevisPhotoGarantie,
  DevisPhotoVariable,
  DevisPhotoFrais
} from 'api/quote';

export {
  CardStatusDtoStatusEnum,
  ContractualizationResponseDtoStatusCategoryEnum,
  ContractualizationResponseDtoStatusSeverityEnum,
  ContractualizationResponseDtoContractSignatureStatusEnum,
  ContractualizationResponseDtoMandateSignatureStatusEnum,
  EtatValidationDevisModeEnum,
  DemandeValidationDtoStatutEnum
} from 'api/quote';

// Alias pour simplifier l'usage
export type StatusCategory =
  | 'Draft'
  | 'Accepted'
  | 'Cancelled';

export type StatusSeverity = 'Critical' | 'Warning' | 'Success' | 'Neutral';

export type SignatureStatusValue = 'ToSign' | 'WaitingSignature' | 'Signed';

export type CardStatusValue = 'Valid' | 'Critical' | 'InProgress';

// ============================================
// Helpers de mapping
// ============================================

/**
 * Mappe un statut API vers CardState
 */
export const mapApiStatusToCardState = (
  status: CardStatusDtoStatusEnum | string | undefined
): CardState => {
  switch (status) {
    case 'Valid':
    case CardStatusDtoStatusEnum.Valid:
      return CardState.VALID;
    case 'Critical':
    case CardStatusDtoStatusEnum.Critical:
      return CardState.CRITICAL;
    case 'InProgress':
    case CardStatusDtoStatusEnum.InProgress:
      return CardState.IN_PROGRESS;
    default:
      return CardState.CRITICAL;
  }
};

/**
 * Mappe un statut de signature API vers ContractStatus
 */
export const mapApiSignatureToContractStatus = (
  status: SignatureStatusValue | string | null | undefined
): ContractStatus => {
  switch (status) {
    case 'Signed':
      return ContractStatus.SIGNED;
    case 'WaitingSignature':
      return ContractStatus.WAITING_SIGNATURE;
    case 'ToSign':
      return ContractStatus.TO_SIGN;
    default:
      return ContractStatus.TO_SIGN;
  }
};
